module.exports = __webpack_public_path__ + "img/Frame_04.db3b8380.png";